<template>
  <div>
    <div :id="'text' + index" class="content" v-html="container" />
    <el-button
      v-show="showBtn"
      style="float: right"
      type="text"
      class="extendBtn"
      @click="toggleBtn"
    >
      {{ extend ? extendText : collampText }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'Longtext',
  props: {
    container: {
      type: String,
      default: () => ''
    },
    // 固定展示行数，超过此行数将进行折叠展示
    lineClamp: {
      type: Number,
      default: 3
    },
    // 行高
    lineHeight: {
      type: Number,
      default: 20
    },
    // 字体大小
    fontSize: {
      type: Number,
      default: 14
    },
    // 展开按钮文案
    extendText: {
      type: String,
      default: '查看更多'
    },
    // 收起按钮文案
    collampText: {
      type: String,
      default: '收起更多'
    },
    // 必传 对应不同id
    index: Number
  },
  data() {
    return {
      extend: true,
      showBtn: false,
      textNode: ''
    }
  },
  computed: {},
  watch: {
    container() {
      console.log('container watcher')
      this.judgeOverHeight()
    }
  },
  mounted() {
    this.judgeOverHeight()
  },
  created() {},
  methods: {
    toggleBtn() {
      if (this.extend) {
        this.textNode.className = 'extend'
      } else {
        this.textNode.className = 'overHeight'
      }
      this.extend = !this.extend
    },
    judgeOverHeight() {
      this.$nextTick(() => {
        this.textNode = document.getElementById('text' + this.index)
        this.textNode.style.fontSize = this.fontSize + 'px'
        // this.textNode.style.overflowWrap = 'anywhere'
        this.textNode.style.lineHeight = this.lineHeight + 'px'
        console.log(this.textNode.innerHTML)
        console.log(this.textNode.offsetHeight, 'height')
        if (this.textNode.offsetHeight > this.lineHeight * 3) {
          this.textNode.className = 'overHeight'
          this.showBtn = true
          console.log('overheight')
        } else {
          this.showBtn = false
          this.textNode.className = 'extend'
        }
      })

      console.log(this.textNode.style)
    }
  }
}
</script>
<style lang="scss" scoped>
.overHeight {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  font-size: 14px;
}
.extend {
  overflow-wrap: anywhere;
}
.content {
  overflow-wrap: anywhere;
}
</style>
